module.exports = __webpack_public_path__ + "img/WP2023-Presenter-1200-1200.3118c951.png";